import React from 'react';
import '../src/index.css'
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from '@chakra-ui/react'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <React.StrictMode>
  <BrowserRouter>
  <ChakraProvider>
      <App/>
      </ChakraProvider>
  </BrowserRouter>
  </React.StrictMode>
    
  </>
);


